export default defineAppConfig({
  ui: {
    colors: {
      primary: 'fpc',
      neutral: 'stone',
      FPC: 'pink',
      FIN: 'fin',
    },

    // Toasts carry the "order created" confirmation, which used to lose the user's attention
    // to the validation text inside the form. These classes are merged over the Nuxt UI
    // defaults by tailwind-merge, so only the properties named here change.
    toaster: {
      slots: {
        // Default is sm:w-96; mobile stays at w-[calc(100%-2rem)].
        viewport: 'sm:w-[26rem]',
      },
    },
    toast: {
      slots: {
        root: 'p-5 gap-3',
        title: 'text-base font-semibold',
        icon: 'size-6',
      },
    },
  },
})
